import React from "react"
import { Link } from "gatsby"

const HeroSectionCandidate = ({ hero, heroImage, href, locale }) => {
  return (
    <section className="py-9">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5 text-center text-lg-left">
            <h1>{hero.title}</h1>
            <div className="lead mb-3">{hero.subtitle}</div>
            <div className="mb-3">
              <a className="cta" href={href}>
                {hero.button}
              </a>
            </div>
            <Link
              className="text-muted"
              to={{ "en-us": "/", "de-de": "/de" }[locale]}
            >
              <u>{hero.link}</u>
            </Link>
          </div>
          <div className="col-md-7 pt-5 pt-md-0">
            <img
              alt="MoBerries Hero-Home"
              className="img-fluid"
              src={heroImage}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroSectionCandidate
